import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
export default {
    saveCollectionPoint,
    getAll,
    getAllDetails,
    editData,
    getFactories,
    getGroups,
    getEstates,
    getDivisions,
    getCollectionCategories,
    GetCollectionPointByFactoryId
};

async function saveCollectionPoint(data) {
    // alert('inside save');
    // alert(JSON.stringify(data));

    let collectionpoint = {
        collectionpointID: 0,
        collectionpointCode: data.collectionpointCode,
        collectionpointName: data.collectionpointName,
        collectionpointLocation: data.collectionpointLocation,
        collectionCategoryID: parseInt(data.collectionCategoryID),
        estateID: parseInt(data.estateID),
        factoryID: parseInt(data.factoryID),
        // groupId: parseInt(data.groupId),
        isActive: true,
        createdBy: 0,
        createdDate: new Date().toISOString(),
        modifiedBy: 0,
        modifiedDate: new Date().toISOString()
    }
    //  alert('befor calling common inside save');
    //   alert(JSON.stringify(collectionpoint));
    const response = await CommonPost('/api/CollectionPoint/SaveCollectionPoint', null, collectionpoint);
    return response;
}

async function getAll() {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null)
    return response.data


}

async function getAllDetails() {
    const response = await CommonGet('/api/CollectionPoint/GetAllDetailCollectionPoint', null)
    return response.data


}

async function editData(data) {
    data.modifiedDate = new Date().toISOString()
    const response = await CommonPost('/api/CollectionPoint/UpdateCollectionPoint', null, data);
    return response;
}

async function getGroups() {
    var groupArray = []
    const response = await CommonGet('/api/Group/GetAllGroups', null)

    for (let item of Object.entries(response.data)) {
        groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
    // alert(JSON.stringify(groupArray));
    return response.data
}

async function getFactories() {

    var factoryArray = []
    const response = await CommonGet('/api/Factory/GetAllFactories', null)
    for (let item of Object.entries(response.data)) {
        //groupArray.push(item[1]["groupCode"]) 
        factoryArray[item[1]["FactoryID"]] = item[1]["FactoryName"]
    }
    return response.data
}

async function getEstates() {

    var estateArray = []
    const response = await CommonGet('/api/Estate/GetAllEstates', null)
    for (let item of Object.entries(response.data)) {
        //groupArray.push(item[1]["groupCode"]) 
        estateArray[item[1]["EstateID"]] = item[1]["EstateName"]
    }
    return response.data
}
async function getDivisions() {

    var divisionArray = []
    const response = await CommonGet('/api/Division/GetAllDivisions', null)
    for (let item of Object.entries(response.data)) {
        //groupArray.push(item[1]["groupCode"]) 
        divisionArray[item[1]["DivisionID"]] = item[1]["DivisionName"]
    }
    return response.data
}


async function getCollectionCategories() {

    var collectioncategoryArray = []
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionCategories', null)
    for (let item of Object.entries(response.data)) {
        //groupArray.push(item[1]["groupCode"]) 
        collectioncategoryArray[item[1]["CollectionCategoryID"]] = item[1]["CollectionCategoryName"]
    }
    return response.data
}

async function GetCollectionPointByFactoryId(id) {
    let collectionPoints = [];
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointByFactoryId', 'id=' + id);

    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            collectionPoints[item[1]["collectionPointID"]] = item[1]["collectionPointCode"]
        }
    }
}



